import config from 'config'
import { gotoEditor, gotoDashboard, publishAndActivate } from 'controllers/shopifyApp'
import { store } from '../index'

const STATIC_URL = config.staticURL

export function initShopifyEmbeddedSDK (apiKey, shopUrl) {
  try {
    const SA = ShopifyApp // eslint-disable-line no-undef
    if (SA) {
      SA.init({
        apiKey: apiKey,
        shopOrigin: `https://${shopUrl}`,
        forceRedirect: false
      })
    } else {
      console.warn('Shopify embedded sdk does not exist')
    }
  } catch (e) {
    console.log('Init shopify app error', e)
  }
}

export function initShopifyBar () {
  try {
    const SA = ShopifyApp // eslint-disable-line no-undef
    if (SA) {
      console.log('Initializing Bar')
      SA.Bar.loadingOff()
      SA.Bar.initialize({
        icon: `${STATIC_URL}/static/whimmIcon.png`,
        title: '',
        buttons: {
          secondary: {
            label: 'Save and close',
            callback: gotoDashboard
          }
        }
      })
    } else {
      console.warn('Shopify embedded sdk does not exist')
    }
  } catch (e) {
    console.log('Init shopify app error', e)
  }
}

export function initShopifyBarFinal (appId) {
  try {
    const SA = ShopifyApp // eslint-disable-line no-undef
    if (SA) {
      console.log('Initializing Bar')
      SA.Bar.loadingOff()
      SA.Bar.initialize({
        icon: `${STATIC_URL}/static/whimmIcon.png`,
        title: '',
        buttons: {
          primary: {
            label: 'Publish live',
            callback: () => {
              store.dispatch(publishAndActivate(appId))
              gotoDashboard()
            }
          }
        }
      })
    } else {
      console.warn('Shopify embedded sdk does not exist')
    }
  } catch (e) {
    console.log('Init shopify app error', e)
  }
}

export function setShopifyBarTitle (title) {
  console.log('set shopify bar title', title)
  const SA = ShopifyApp // eslint-disable-line no-undef
  if (SA) {
    SA.Bar.setTitle(title)
  }
}

export function initDashboardShopifyBar (appId) {
  try {
    const SA = ShopifyApp // eslint-disable-line no-undef
    if (SA) {
      SA.Bar.initialize({
        icon: `${STATIC_URL}/static/whimmIcon.png`,
        title: 'Dashboard',
        buttons: {
          secondary: {
            label: 'Edit your whimm',
            callback: () => {
              gotoEditor(appId)
            }
          }
        }
      })
    } else {
      console.warn('Shopify embedded sdk does not exist')
    }
  } catch (e) {
    console.log('Init shopify app error', e)
  }
}

export function setShopifyBarLoadingOn () {
  const SA = ShopifyApp // eslint-disable-line no-undef
  if (SA) {
    SA.Bar.loadingOn()
  }
}



// WEBPACK FOOTER //
// ./src/controllers/shopifyBar.js